{
  "version": 1,
  "asset_id": "95e0c02e-f257-4307-8ba7-5cc63b303829",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/95e0c02e-f257-4307-8ba7-5cc63b303829/beverly-hills-shingle-roof-underlayment-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/95e0c02e-f257-4307-8ba7-5cc63b303829/beverly-hills-shingle-roof-underlayment-480w.avif",
  "original_filename": "beverly-hills-shingle-roof-underlayment-480w.avif",
  "size": 15594,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:55Z"
}
